import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-6 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-heading font-light text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-2xl md:text-3xl font-heading font-light text-foreground-950 tracking-[0.06em] mt-6">
          ページが見つかりません
        </h1>
        <p className="mt-3 text-sm md:text-base text-foreground-500 tracking-[0.06em] font-sans font-light">
          お探しのページは存在しないか、移動した可能性があります。
        </p>
        <div className="mt-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-800 text-accent-400 text-sm tracking-[0.08em] font-sans font-medium hover:bg-primary-700 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            トップページに戻る
            <i className="ri-arrow-right-line text-base" />
          </Link>
        </div>
      </div>
    </div>
  );
}